/** Parse fee / money percent allowing "," or "." as decimal separator. */
export function parseDecimalInput(raw, { fallback = 0 } = {}) {
  if (raw == null || raw === "") return fallback;
  const normalized = String(raw).trim().replace(/\s+/g, "").replace(",", ".");
  if (normalized === "" || normalized === "." || normalized === "-") return fallback;
  const n = Number(normalized);
  return Number.isFinite(n) ? n : fallback;
}

/** Allow typing decimals with . or , while composing (e.g. "2," or "2.5"). */
export function isDecimalTypingValue(raw) {
  const s = String(raw ?? "").trim().replace(/\s+/g, "");
  return s === "" || /^-?\d*[.,]?\d*$/.test(s);
}
